import React from 'react';
import { Nav, Navbar, Form, FormControl, Dropdown } from 'react-bootstrap';
import styles from './NavigationBar.module.scss'
import styled from 'styled-components';
const Styles = styled.div`
  .navbar { background-color: white; height: 80}
  a, .navbar-nav, .navbar-light .nav-link {
    color: gray;
    &:hover { color: pink; };
    
  }
  .navbar-brand {
    font-size: 1.4em;
    color: pink; 
    &:hover { color: pink; }
  }
  .form-center {
    position: absolute !important;
    left: 50%;
    right: 50%;
  }
`;
export const NavigationBar = () => (
    <Styles>
      <Navbar className={styles.navbar} expand="sm">
        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav classNameclassName="ml-auto">
            <Nav.Item><Nav.Link href="/">welcome</Nav.Link></Nav.Item> 
            <Nav.Item><Nav.Link href="/projects">projects</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link href="/about">about me</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link href="/exhibitions">exhibitions</Nav.Link></Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Styles>
  )